import { IDashboardMetadata } from '../dashboard-metadata.service';
import { countryHitRateIndicator, FULL_HEIGHT_GRID, HIT_RATE_FIXED_FILTERS, HIT_RATE_MAPPINGS } from './shared-dashboard.config';
import {
  HitRateDashboardFiltersComponent,
  HitRateType
} from '../filters/hit-rate/hit-rate-dashboard-filters.component';

export const COUNTRY_HIT_RATE_COLUMNS = [
  'Webshopsetup',
  'Desprnm',
  'Desprst_ds',
  'Deordga_ds',
  {
    name: 'Countryhitrate',
    groupingSequence: 0
  },
  {
    name: 'Decounm',
    groupingSequence: 1
  },
  'Deconti',
  'Pacomnm',
  'Denrusr',
  'Deordpr_ds',
  'Deexpoy',
  'Detotal',
  'Detotlo',
  'Improdt',
  'Deucnok',
  'Icprodt',
  'Losprst_ds',
  'Lostaco',
  'Losprdt',
  'Delamcn',
  'Cglname',
  'Gblname',
  'Derqbco',
  'Destaco',
  'Allowed_to_contact_local_customer_ds'
];

export const COUNTRY_HIT_RATE_DASHBOARD_CONFIG:IDashboardMetadata = {
  title: 'Country Hit Rate KPI',
  filterComponent: {
    name: HitRateDashboardFiltersComponent,
    inputs: {
      hitRateType: HitRateType.COUNTRY
    }
  },
  mapping: {
    Pacomnm: 'bp.companyCountryId',
    Pacgrid: 'bpGroup.id',
    Odlname: 'pss.id',
    Oddesk: 'bpDesk',
    Decounm: 'country.id'
  },
  reports: [
    {
      id: 175,
      key: 'CUSTOMERS_IN_COUNTRY',
      comments: 'All customers in 1 country',
      columns: COUNTRY_HIT_RATE_COLUMNS,
      gridHeight: FULL_HEIGHT_GRID,
      partialRender: true,
      fixedFilters: HIT_RATE_FIXED_FILTERS,
      mapping: HIT_RATE_MAPPINGS,
      indicatorFn: countryHitRateIndicator
    }
  ]
};